import React from "react";

const PokemonNavbar = () => {
  const baseUrl = "https://thekylekenney.com";
  return (
    <nav className="bg-red-600 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center py-3">
          <a
            className="text-white no-underline font-semibold text-lg hover:text-gray-200"
            href={`${baseUrl}/#Home`}
          >
            Back To Home
          </a>
          <div>
            <a
              className="text-white no-underline hover:text-gray-200"
              href={`${baseUrl}/#Projects`}
            >
              Other Projects
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PokemonNavbar;
